// frontend/src/api/CNAuBPIXEFileApi.js (ejemplo)

import api from "./api";

// Obtener todos los archivos
export const fetchCNAuBPIXEFiles = async () => {
  try {
    const response = await api.get("/cna-ub-pixe-files/");
    return response.data;
  } catch (error) {
    console.error("Error fetching CNA uB PIXE file records:", error);
    throw error;
  }
};

// Obtener un archivo por ID
export const fetchCNAuBPIXEFileById = async (id) => {
  try {
    const response = await api.get(`/cna-ub-pixe-files/${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching CNA uB PIXE file with ID ${id}:`, error);
    throw error;
  }
};

// Obtener archivos de propuesta
export const listCNAuBPIXEFilesByProposal = async (proposalId) => {
  const response = await api.get(`/cna-ub-pixe-files/proposal/${proposalId}/`);
  return response.data;
};

// Buscar archivos por nombre (contiene)
export const searchCNAuBPIXEFiles = async (query) => {
  try {
    const response = await api.get(`/cna-ub-pixe-files/?search=${encodeURIComponent(query)}`);
    return response.data;
  } catch (error) {
    console.error(`Error searching CNA uB PIXE files with query "${query}":`, error);
    throw error;
  }
};

// Crear un nuevo archivo
export const createCNAuBPIXEFile = async (data) => {
  try {
    const response = await api.post("/cna-ub-pixe-files/", data);
    return response.data;
  } catch (error) {
    console.error("Error creating CNA uB PIXE file:", error);
    throw error;
  }
};

// Actualizar un archivo (solo si es del usuario)
export const updateCNAuBPIXEFile = async (id, data) => {
  try {
    const response = await api.put(`/cna-ub-pixe-files/${id}/`, data);
    return response.data;
  } catch (error) {
    console.error(`Error updating CNA uB PIXE file with ID ${id}:`, error);
    throw error;
  }
};

// Eliminar un archivo (solo si es del usuario)
export const softDeleteCNAuBPIXEFile = async (id) => {
  try {
    const response = await api.delete(`/cna-ub-pixe-files/${id}/`);
    return response.data;
  } catch (error) {
    console.error("Error soft-deleting CNA uB PIXE files:", error);
    throw error;
  }
};

// Exportar archivos por nombre
/*export const exportCMAMTOFERDAFilesByName = async (namesArray) => {
  try {
    const namesParam = namesArray.map(encodeURIComponent).join(",");
    const response = await api.get(`/cmam-toferda-files/export/?names=${namesParam}`, {
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error exporting CMAM TOFERDA files by name:", error);
    throw error;
  }
};*/

// Exportar archivos CNA_uB_PIXE_File por ID
export const exportCNAuBPIXEFilesById = async (idsArray) => {
  try {
    const idsParam = idsArray.join(",");
    const response = await api.get(`/cna-ub-pixe-files/export/?ids=${idsParam}`, {
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error exporting CNA uB PIXE file by ID:", error);
    throw error;
  }
};

// Filtros generales
export const filterCNAuBPIXEFiles = async (params) => {
  try {
    const query = new URLSearchParams(params).toString();
    const response = await api.get(`/cna-ub-pixe-files/?${query}`);
    return response.data;
  } catch (error) {
    console.error("Error filtering CNA uB PIXE files:", error);
    throw error;
  }
};
